import Container from "@/components/ui/Container";
import SectionLabel from "@/components/ui/SectionLabel";
import GradientHeading from "@/components/ui/GradientHeading";

const steps = [
  {
    title: "Обнаружение",
    desc: [
      "Выявление уязвимости в Ключ-АСТРОМ в реальном времени",
      "Без приостановки и тех.окна",
    ],
  },
  {
    title: "Алерты",
    desc: ["Автоматическое уведомление команды"],
  },
  {
    title: "Разработка",
    desc: [
      "Автоматическое создание задачи",
      "Исправление и внесение изменений от разработки",
    ],
  },
  {
    title: "Автоматическая проверка ИБ",
    desc: ["Повторное сканирование и подтверждение исправления"],
  },
  {
    title: "48 часов → 4 часа",
    desc: [
      "Весь процесс проходит без ручного поиска, передачи информации между командами и повторных проверок",
    ],
    highlight: true,
  },
];

export default function KeyAstromSection() {
  return (
    <section>
      <Container>
        <div className="xl:grid xl:grid-cols-2 xl:gap-5">
          <div className="xl:sticky xl:top-[140px] xl:self-start xl:mb-[180px]">
            <SectionLabel>Автоматизация всего цикла</SectionLabel>
            <GradientHeading className="mt-3 xl:tracking-[-1.2px]">
              МИБ в Ключ-АСТРОМ
            </GradientHeading>
            <p className="mt-[30px] text-[16px] font-medium leading-[1.3] text-ink xl:max-w-[607px] xl:text-[18px]">
              Устраняет уязвимости в 12 раз быстрее
            </p>
          </div>

          <div className="relative mt-[60px] flex flex-col gap-2.5 min-[478px]:gap-5 xl:mt-0">
            <span
              aria-hidden
              className="pointer-events-none absolute inset-y-0 left-1/2 w-1 -translate-x-1/2 bg-surface"
            />
            {steps.map((step, i) => (
              <div
                key={step.title}
                className={`relative flex min-h-[160px] flex-col justify-between rounded-[25px] px-5 py-[26px] md:px-9 ${
                  step.highlight ? "bg-brand-gradient" : "bg-surface"
                }`}
              >
                <div className="flex items-start justify-between gap-4">
                  <h3
                    className={`text-[21px] font-bold leading-none tracking-[-0.21px] ${
                      step.highlight ? "text-white" : "text-navy"
                    }`}
                  >
                    {step.title}
                  </h3>
                  {!step.highlight && (
                    <div className="flex size-[44px] shrink-0 items-center justify-center rounded-[5px] bg-white">
                      <span className="text-[16px] font-bold leading-none text-coral">
                        {i + 1}
                      </span>
                    </div>
                  )}
                </div>

                <div
                  className={`mt-6 text-[16px] font-medium leading-[1.3] ${
                    step.highlight ? "text-white" : "text-ink"
                  }`}
                >
                  {step.desc.map((line) => (
                    <p key={line}>{line}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
